import { Icon } from "components";

const legendItems: any = {
    0: [
      {
        icon: <Icon materialIcon="CarCrashTwoTone" color="#FF0000" />,
        label: 'Crash',
      },
      {
        icon: <Icon materialIcon="WarningAmberTwoTone" color="#FF0000" />,
        label: 'Critical Tailgating',
      },
      {
        icon: <Icon materialIcon="ArrowUpwardTwoTone" color="#FF0000" />,
        label: 'Harsh Acceleration',
      },
      {
        icon: <Icon materialIcon="SpeedTwoTone" color="#FF0000" />,
        label: 'Harsh Braking',
      },
      {
        icon: <Icon materialIcon="TurnLeftTwoTone" color="#FF0000" />,
        label: 'Harsh Corner',
      },
      {
        icon: <Icon materialIcon="DirectionsCarTwoTone" color="#FF0000" />,
        label: 'Lane Departure',
      },
      {
        icon: <Icon materialIcon="DirectionsCarTwoTone" color="#FF0000" />,
        label: 'Near Collision',
      },
      {
        icon: <Icon materialIcon="ReportProblemTwoTone" color="#FF0000" />,
        label: 'Other',
      },
      {
        icon: <Icon materialIcon="WrongLocationTwoTone" color="#FF0000" />,
        label: 'Parked On Highway Ramp',
      },
      {
        icon: <Icon materialIcon="CarCrashTwoTone" color="#FF0000" />,
        label: 'Possible Accident',
      },
      {
        icon: <Icon materialIcon="RemoveRoadTwoTone" color="#FF0000" />,
        label: 'Rough Uneven Surface',
      },
      {
        icon: <Icon materialIcon="SyncProblemTwoTone" color="#FF0000" />,
        label: 'Roll Stability',
      },
      {
        icon: <Icon materialIcon="TrafficTwoTone" color="#FF0000" />,
        label: 'Sign Violation Or Rolling',
      },
      {
        icon: <Icon materialIcon="WarningAmberTwoTone" color="#FF0000" />,
        label: 'Tailgating',
      },
      {
        icon: <Icon materialIcon="VibrationTwoTone" color="#FF0000" />,
        label: 'Shock',
      },
      {
        icon: <Icon materialIcon="VisibilityOffTwoTone" color="#FF0000" />,
        label: 'Blind Spot',
      },
      {
        icon: <Icon materialIcon="TimerTwoTone" color="#FF0000" />,
        label: 'Idling',
      },
      {
        icon: <Icon materialIcon="PersonOffTwoTone" color="#FF0000" />,
        label: 'Unauthorized Driver',
      },
      {
        icon: <Icon materialIcon="SwapHorizTwoTone" color="#FF0000" />,
        label: 'Lane Violation',
      },
      {
        icon: <Icon materialIcon="ArrowDownwardTwoTone" color="#FF0000" />,
        label: 'Backing',
      },
      {
        icon: <Icon materialIcon="EventSeatTwoTone" color="#FF0000" />,
        label: 'Cabin Occupancy',
      },
      {
        icon: <Icon materialIcon="NotificationsActiveTwoTone" color="#FF0000" />,
        label: 'Theft Alarm',
      },
      {
        icon: <Icon materialIcon="FactCheckTwoTone" color="#FF0000" />,
        label: 'Dvir Defect',
      },
      {
        icon: <Icon materialIcon="ScheduleTwoTone" color="#FF0000" />,
        label: 'Hos Violation',
      },
      {
        icon: <Icon materialIcon="AvTimerTwoTone" color="#FF0000" />,
        label: 'Operating Hours Violation',
      },
      {
        icon: <Icon materialIcon="AssessmentTwoTone" color="#FF0000" />,
        label: 'Driving Score',
      },
      {
        icon: <Icon materialIcon="InventoryTwoTone" color="#FF0000" />,
        label: 'Cargo Violation',
      },
      {
        icon: <Icon materialIcon="DirectionsWalkTwoTone" color="#FF0000" />,
        label: 'Pedestrian',
      },
      {
        icon: <Icon materialIcon="MasksTwoTone" color="#FF0000" />,
        label: 'Face Mask Check',
      },
      {
        icon: <Icon materialIcon="SettingsInputComponentTwoTone" color="#FF0000" />,
        label: 'Aux Input',
      },
      {
        icon: <Icon materialIcon="EventAvailableTwoTone" color="#FF0000" />,
        label: 'Driver Attendance',
      },
      {
        icon: <Icon materialIcon="KeyTwoTone" color="#FF0000" />,
        label: 'Ignition',
      },
      {
        icon: <Icon materialIcon="RouteTwoTone" color="#FF0000" />,
        label: 'Trip State',
      },
      {
        icon: <Icon materialIcon="DeviceUnknownTwoTone" color="#FF0000" />,
        label: 'Device Fault',
      },
      {
        icon: <Icon materialIcon="WifiOffTwoTone" color="#FF0000" />,
        label: 'Device Connectivity',
      },
      {
        icon: <Icon materialIcon="PowerTwoTone" color="#FF0000" />,
        label: 'Device Power',
      },
      {
        icon: <Icon materialIcon="BatteryAlertTwoTone" color="#FF0000" />,
        label: 'Low Battery',
      },
      {
        icon: <Icon materialIcon="LocalGasStationTwoTone" color="#FF0000" />,
        label: 'Fuel Event',
      },
      {
        icon: <Icon materialIcon="BuildTwoTone" color="#FF0000" />,
        label: 'Maintenance',
      },
      {
        icon: <Icon materialIcon="VideocamTwoTone" color="#FF0000" />,
        label: 'Video Operation',
      },
      {
        icon: <Icon materialIcon="HelpOutlineTwoTone" color="#FF0000" />,
        label: 'Not Specified Event',
      },
      {
        icon: <Icon materialIcon="QuestionMarkTwoTone" color="#FF0000" />,
        label: 'Unknown Event',
      },
    ],
    1: [
      {
        icon: <Icon materialIcon="LocationOnTwoTone" color="#007BFF" />,
        label: 'Route Start',
      },
      {
        icon: <Icon materialIcon="LocationOnTwoTone" color="#6A0DAD" />,
        label: 'Route End',
      },
      {
        icon: <Icon materialIcon="HorizontalRule" color="#0096FF" />,
        label: 'Normal Speed',
      },
      {
        icon: <Icon materialIcon="HorizontalRule" color="#FF8000" />,
        label: 'Speeding',
      },
      {
        icon: <Icon materialIcon="HorizontalRule" color="#FF0000" />,
        label: 'Speeding (10+ mph)',
      },
      {
        icon: <Icon materialIcon="HorizontalRule" color="#A200ED" />,
        label: 'Speeding (15+ mph)',
      },
      {
        icon: <Icon materialIcon="HorizontalRule" color="#1F001F" />,
        label: 'Speeding (20+ mph)',
      },
    ],
  }

  export default legendItems;